import PropertyHistory from './PropertyHistory';
import {connect} from 'react-redux';
import {getFetchingFromState} from 'lib/PropertyUtils';
import {PROPERTY_HISTORY_FIELDS} from 'lib/Commons';

const mapStateToProps = (state) => ({
  history: state.propertyDetail.history ?? [],
  isLoading: state.featureFlags?.rapidSearchEnabled && getFetchingFromState({
    propertyId: state.propertyDetail.propertyId,
    state,
    updateFields: PROPERTY_HISTORY_FIELDS,
  }),
});
export default connect(mapStateToProps)(PropertyHistory);